import { useState } from 'react';
import './ChecklistItemRow.css';

export default function ChecklistItemRow({ item, onUpdate, onDelete, isDragging, dragOver, onDragStart, onDragOver, onDrop, onDragEnd, index }) {
  const [showHint, setShowHint] = useState(false);

  return (
    <div
      className={`checklist-row ${isDragging ? 'checklist-row--dragging' : ''} ${dragOver ? 'checklist-row--drag-over' : ''}`}
      draggable={true}
      onDragStart={onDragStart}
      onDragOver={e => { e.preventDefault(); onDragOver(); }}
      onDrop={onDrop}
      onDragEnd={onDragEnd}
    >
      <div className="checklist-row__grip">{'\u2807'}</div>
      <div className="checklist-row__num">{index + 1}</div>

      <div className="checklist-row__inputs">
        <input
          type="text"
          className="checklist-row__text"
          value={item.text}
          onChange={e => onUpdate({ ...item, text: e.target.value })}
          placeholder="Checklist item..."
        />
        {showHint ? (
          <input
            type="text"
            className="checklist-row__hint-input"
            value={item.hint || ''}
            onChange={e => onUpdate({ ...item, hint: e.target.value })}
            placeholder="Optional hint/guidance..."
          />
        ) : (
          item.hint && <div className="checklist-row__hint">&#128161; {item.hint}</div>
        )}
      </div>

      <div className="checklist-row__toggles">
        <label className="checklist-row__req-label">
          <input
            type="checkbox"
            className="checklist-row__checkbox"
            checked={item.required}
            onChange={e => onUpdate({ ...item, required: e.target.checked })}
          />
          Required
        </label>

        <button className="checklist-row__hint-btn" onClick={() => setShowHint(!showHint)}>
          {showHint ? '- Hint' : '+ Hint'}
        </button>

        <button className="checklist-row__delete-btn" onClick={() => onDelete(item.uid)}>
          {'\u2715'}
        </button>
      </div>
    </div>
  );
}
